module.exports = __webpack_public_path__ + "img/green-arrow.112b4b71.svg";